import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrencyPipe, DialogBase, ImageType, ObjectTypeInfo, T4Image, T4RentalService } from 't4core';

@Component({
  selector: 't4-UploadImageDialog',
  templateUrl: 'UploadImageDialog.html',
})
export class UploadImageDialog extends DialogBase implements OnInit {
  public imageType: ImageType;
  public entityId: string = "";

  @ViewChild("txtFile") private txtFile: ElementRef;

  constructor(public dialogRef: MatDialogRef<UploadImageDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService, private cPipe: CurrencyPipe) {
    super("UploadImageDialog");

    this.imageType = data.imageType;
    this.entityId = data.entityId;
  }

  async ngOnInit() {
    setTimeout(() => this.txtFile.nativeElement.click(), 250);
  }

  public async upload(files: FileList) {
    let me = this;
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async function () {
      console.log(reader.result);
      await me.Api.post<T4Image>("Data/SetImage", "\"" + reader.result.toString() + "\"", { type: me.imageType, entityId: me.entityId });
      var image = await me.Api.get<T4Image>("Data/GetImage", { type: me.imageType, entityId: me.entityId });

      me.dialogRef.close(image);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
}
